import { SET_CURRENT_RUN, SET_CURRENT_TENANT, SET_SUMMARY_REPORT, CLEAR_SUMMARY_REPORT } from '../actions/modelValidation';
import modelValidationClient from '@/services/modelValidationClient';

const state = {
  runConfig: {},
  chosenTenant: '',
  summaryReport: {}
};

const getters = {
  runConfig: (state) => state.runConfig,
  chosenTenant: (state) => state.chosenTenant,
  summaryReport: (state) => state.summaryReport,
  dataSourcesKeyWords: (state) => state.chosenTenant.dataSourcesKeyWords
};

const actions = {
  [SET_CURRENT_RUN]: ({ commit }, currentRun) => {
    commit(SET_CURRENT_RUN, currentRun);
  },

  [SET_CURRENT_TENANT]: async ({ commit }, currentTenant) => {
    // console.log('Current Tenant Value:', currentTenant.value);  // Debugging log
    
    // Move the API request here in actions
    if (currentTenant.value) {
      try {
        const tenantDataResponse = await modelValidationClient.getTenants(currentTenant.value);
        // console.log('API Response:', tenantDataResponse.data);  // Log the response
  
        const tenant = tenantDataResponse.data.find(({ tenantId }) => tenantId === currentTenant.value);
  
        // Commit mutations to update the state
        if (tenant) {
          commit(SET_CURRENT_TENANT, tenant);  // Commit the tenant data
        } else {
          console.warn('No matching tenant found for ID:', currentTenant.value);
        }
      } catch (err) {
        console.error('API Error:', err);
      }
    } else {
      // console.log('No current tenant value provided.');  // Log when no value is provided
      commit(SET_CURRENT_TENANT, '');  // Commit the tenant data
    }
  },  

  [SET_SUMMARY_REPORT]: ({ commit }) => {
    modelValidationClient.getSummaryReport()
      .then(summaryReportResponse => {
        commit(SET_SUMMARY_REPORT, summaryReportResponse.data); // commit the summary report data
      })
      .catch(err => {
        console.error(err);
      });
  },

  [CLEAR_SUMMARY_REPORT]: ({ commit }) => {
    commit(CLEAR_SUMMARY_REPORT)
  }
};

const mutations = {
  [SET_CURRENT_RUN]: (state, data) => {
    state.runConfig = data;
  },
  [SET_CURRENT_TENANT]: (state, tenant) => {

    if (tenant) {
      // samples / tests
      const canCreateSamplesTests = tenant.tenantType === 'auditor' || tenant.isPrimary
      localStorage.setItem("isPrimary", canCreateSamplesTests);
    }

    state.chosenTenant = tenant; // Mutate chosenTenant state
  },
  [SET_SUMMARY_REPORT]: (state, data) => {
    
    state.summaryReport = data.sort((a, b) => {
        return new Date(b._source.createdAt) - new Date(a._source.createdAt);
    }); // Mutate summaryReport state
  },
  [CLEAR_SUMMARY_REPORT]: (state) => {
    state.summaryReport = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
